<div class="invite-expired-parent">
  <div class="invite-expired-setup">
    <div class="row">
      <div class="col-12">
        <div class="error-flow">
          <div class="heading">
            <adp-label labelKey="Signup_InviteExpired_Heading_Text"></adp-label>
          </div>
          <div class="error-subheading-container">
            <div class="subheading">
              <adp-label labelKey="Signup_InviteExpired_Body_Text"></adp-label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="background-width">
  </div>
</div>
